(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8088],{

/***/ 5563:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authorship",
      function () {
        return __webpack_require__(53903);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 53903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(43692);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2746);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44453);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8014);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50744);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70443);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94644);
/* harmony import */ var enums_namespaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99731);
/* harmony import */ var next_translate_Trans__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46834);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62044);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56168);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46323);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(45744);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1984);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var helpers_jsx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(28808);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52662);
/* harmony import */ var api_client__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(66564);




// @ts-ignore













var Authorship = function(param) {
    var countryCode = param.countryCode;
    var EMAIL_MAX_LENGTH = 100;
    var MESSAGE_MAX_LENGTH = 2000;
    var user = (0,context__WEBPACK_IMPORTED_MODULE_12__/* .useAuth */ .aC)().user;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(enums_namespaces__WEBPACK_IMPORTED_MODULE_5__/* .Namespace.Authorship */ .l.Authorship).t;
    var createNotification = (0,context__WEBPACK_IMPORTED_MODULE_12__/* .useNotificationContext */ .nw)().createNotification;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_8__.useState(false), 2), wasSendSuccess = ref[0], setWasSendSuccess = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_8__.useState({
        email: "",
        message: ""
    }), 2), initialValues = ref1[0], setInitialValues = ref1[1];
    var validationSchema = function() {
        var field_required = t("authorship_field_required");
        var max_length = t("authorship_max_length");
        var invalid_email = t("authorship_email_invalid");
        var formSchema = yup__WEBPACK_IMPORTED_MODULE_4__/* .object */ .Ry().shape({
            email: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().email(invalid_email).max(EMAIL_MAX_LENGTH, "".concat(max_length, " ").concat(EMAIL_MAX_LENGTH)).required(field_required),
            message: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().max(MESSAGE_MAX_LENGTH, "".concat(max_length, " ").concat(MESSAGE_MAX_LENGTH)).required(field_required)
        });
        return formSchema;
    };
    var onSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values, param) {
            var resetForm, emailIn;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        resetForm = param.resetForm;
                        _ctx.prev = 1;
                        emailIn = {
                            subject: "Authorship claim",
                            sender: values.email,
                            body: values.message,
                            type: "COPYRIGHT"
                        };
                        if (user) {
                            delete emailIn.sender;
                        }
                        _ctx.next = 6;
                        return (0,api_client__WEBPACK_IMPORTED_MODULE_13__/* .getSharedApiClient */ .L)().sendEmail(emailIn);
                    case 6:
                        // Reset form & show success message on OK send
                        createNotification({
                            title: t("authorship_email")
                        });
                        setWasSendSuccess(true);
                        resetForm();
                        setTimeout(function() {
                            setWasSendSuccess(false);
                        }, 2000);
                        _ctx.next = 16;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        createNotification({
                            title: t("authorship_email_fail")
                        });
                        setWasSendSuccess(false);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12
                ]
            ]);
        }));
        return function onSubmit(values, _) {
            return _ref.apply(this, arguments);
        };
    }();
    react__WEBPACK_IMPORTED_MODULE_8__.useEffect(function() {
        if (user && user.email) {
            setInitialValues({
                email: user.email,
                message: ""
            });
        }
    }, [
        user
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_10___default()), {
                children: (0,helpers_jsx__WEBPACK_IMPORTED_MODULE_11__/* .basicSEO */ .F)(t("seo:authorship_title"), t("seo:authorship_description"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("main", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().authorship),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().sectionWrapper),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().heading),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                    children: t("menu_authorship")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    i18nKey: "authorship:authorship_perex",
                                    components: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {})
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().sectionWrapper), (_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().form), (_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().withBackground), (_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().reverse)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().heading),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                    children: t("authorship_title")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Formik */ .J9, {
                                initialValues: initialValues,
                                onSubmit: onSubmit,
                                validationSchema: validationSchema(),
                                enableReinitialize: true,
                                children: function(param) {
                                    var values = param.values, setFieldValue = param.setFieldValue, isSubmitting = param.isSubmitting, touched = param.touched, errors = param.errors;
                                    var ref;
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Form */ .l0, {
                                        autoComplete: "off",
                                        children: [
                                            !user && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                                children: [
                                                    t("authorship_your_email"),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                        type: "text",
                                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().email), {
                                                            error: touched.message && errors.message
                                                        }),
                                                        name: "email",
                                                        id: "email",
                                                        value: values.email,
                                                        onChange: function(e) {
                                                            var ref;
                                                            return setFieldValue("email", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                        }
                                                    }),
                                                    touched.email && errors.email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        className: "d-block",
                                                        children: errors.email
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                                children: [
                                                    t("authorship_message_for_us"),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("textarea", {
                                                        maxLength: 2000,
                                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().question), "required", {
                                                            error: touched.message && errors.message
                                                        }),
                                                        id: "question",
                                                        value: values.message,
                                                        onChange: function(e) {
                                                            var ref;
                                                            return setFieldValue("message", e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                        }
                                                    }),
                                                    touched.message && errors.message && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        className: "d-block",
                                                        children: errors.message
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().controls),
                                                id: "controls",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                        id: "remaining",
                                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().remaining),
                                                        children: [
                                                            ((ref = values.message) === null || ref === void 0 ? void 0 : ref.length) || 0,
                                                            " / ",
                                                            MESSAGE_MAX_LENGTH
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                                                        type: "submit",
                                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().btn), "btn", "btn-primary"),
                                                        disabled: isSubmitting || wasSendSuccess,
                                                        children: [
                                                            isSubmitting && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("spinner-border", (_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().spinner)),
                                                                role: "status",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                    className: "sr-only",
                                                                    children: "Loading..."
                                                                })
                                                            }),
                                                            wasSendSuccess ? t("authorship_email") : t("authorship_send_form")
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().sectionWrapper), (_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().provider), (_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().withBackground)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().heading),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                    children: t("authorship_provider")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().info),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("address", {
                                    children: [
                                        "Dramox s.r.o.",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                        "Bucharova 2928/14a, Stod\u016Flky",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                        "I\u010CO: 09222103"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Authorship);


/***/ }),

/***/ 45744:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"authorship":"authorship_authorship__5h47l","sectionWrapper":"authorship_sectionWrapper__OJCNz","heading":"authorship_heading__F_fXN","form":"authorship_form__xvpwG","question":"authorship_question__etpjF","email":"authorship_email__3aTNW","controls":"authorship_controls__rYC4J","remaining":"authorship_remaining__RoCRP","withBackground":"authorship_withBackground__RmzyQ","reverse":"authorship_reverse__S9S_F","provider":"authorship_provider__iJgJX","btn":"authorship_btn__D_ZDZ","spinner":"authorship_spinner__uGNuR"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [443,9774,2888,179], function() { return __webpack_exec__(5563); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);